import React from 'react'

function AssignmentWelcome() {
    return (
        <div>
            Willkommensnachricht / Erklärung folgt...
        </div>
    )
}

export default AssignmentWelcome
